import { CookieModal, CookieModalConfig } from './modals/CookieModal.js';
import { CookieManager, CookieManagerConfig, CookieType } from './CookieManager.js';

import './modals/CookieModal.css';

export type AppConfig = {
    cookieModalConfig: CookieModalConfig,
    cookieManagerConfig: CookieManagerConfig,
}

/**
 * Класс приложения для управления куками и отображения модального окна согласия.
 *
 * @class
 */
export class CookieApp {
    /**
     * HTML-элемент или селектор, куда будет привязано приложение.
     * @type {HTMLElement|null}
     */
    target = null;

    /**
     * Опции приложения по умолчанию.
     * @type {AppConfig}
     */
    options = {
        /**
         * Конфигурация модального окна.
         * @type {CookieModalConfig}
         */
        cookieModalConfig: {},
        
        /**
         * Конфигурация менеджера кук.
         * @type {CookieManagerConfig}
         */
        cookieManagerConfig: {},
    };

    /**
     * Экземпляр модального окна для управления согласием на куки.
     * @type {CookieModal}
     */
    cookieModal;

    /**
     * Экземпляр менеджера кук.
     * @type {CookieManager}
     */
    cookieManager;

    /**
     * Создаёт экземпляр приложения.
     *
     * @param {string|HTMLElement} target - Селектор или HTML-элемент, в котором будет работать приложение.
     * @param {AppConfig} [options={}] - Пользовательские опции для настройки приложения.
     */
    constructor(target, options = {}) {
        this.target = BX.Type.isString(target) ? document.querySelector(target) : target;
        this.options = {
            ...this.options,
            ...options
        };

        this.init();
    }

    /**
     * Инициализирует компоненты приложения:
     * - создаёт модальное окно для управления куками;
     * - инициализирует менеджер кук с обработкой событий.
     *
     * @returns {void}
     */
    init() {
        this.cookieModal = new CookieModal(this.target, this.options.cookieModalConfig);
        this.cookieManager = new CookieManager({
            onAbsentCookie: () => {
                setTimeout(() => {
                    this.cookieModal.open();
                }, 500);
            },
            onBeforeInit: (cookieManager) => {
                this.cookieModal.target.addEventListener('apply', (e) => {
                    cookieManager.saveUserSettings(e.detail.settings);
                    cookieManager.processInitialState();
                });
            },
            ...this.options.cookieManagerConfig,
        });
    }
}